/**
 * Configuración del componente `Company` del Design System para la selección
 * de cuenta de Admin ART/HyS (PBI #80676).
 */

/** Rótulo del buscador (prototipo 1 — P5.e). */
export const COMPANY_LABEL = 'Cuenta'

/** Cuatro datos → el DS los distribuye en dos filas de dos, como el prototipo. */
export const COMPANY_FIELDS = ['razon-social', 'cuit', 'contrato', 'nro-poliza']

/**
 * P3: Admin ART y Admin HyS buscan en todo el universo de empresas.
 * P4: los contratos inactivos se listan (el DS los marca como «Inactivo») y se
 * puede ingresar a ellos.
 */
export const COMPANY_ALCANCE = {
  allowInactive: true,
  onlyAssociatedCompanies: false,
}

export const COMPANY_TEST_ID = 'seleccion-cuenta-admin-company'
